import { createFileRoute, redirect } from "@tanstack/react-router";

// The free CPA tool was retired; old links land on the guide that explains the same method.
export const Route = createFileRoute("/meta-ads-diagnostic")({
  beforeLoad: () => {
    throw redirect({ to: "/guides/why-meta-ad-costs-rise", statusCode: 301 });
  },
});
